module.exports = __webpack_public_path__ + "img/logo.4c715e56.png";